import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

import { ClientRequestsList } from '../Components/ClientRequestsList'
import { REQUEST_RESOURCE } from '../Contracts/IRequest'

export interface ClientRequestsTabProps {
    /** Значення форми клієнта; без `uuid` (новий клієнт) запитів ще немає */
    record: { uuid?: unknown; '@id'?: unknown; title?: unknown } | undefined
}

/**
 * Чи бачить користувач запити взагалі: колекційне `read_collection`
 * (K, M, L; «Фінанси» без них — ні, Q2.13). За ним картка клієнта ховає
 * вкладку, а не показує 403 усередині.
 */
export const canReadRequests = (): boolean => CheckGlobalResourceAccessTask(REQUEST_RESOURCE, 'read_collection')

/**
 * Публічне API контейнера запитів для картки клієнта (`SPEC-022` §3.4,
 * `SPEC-025` §3.5): вміст вкладки «Запити». Розміщує вкладку в
 * `ClientFormTemplate` наряд оболонки (Н-025.4) — тут лише вміст.
 *
 * Без права на запити або без збереженого клієнта — нічого.
 */
export const ClientRequestsTab = ({ record }: ClientRequestsTabProps) => {
    const uuid = typeof record?.uuid === 'string' && record.uuid !== '' ? record.uuid : null

    if (uuid === null || !canReadRequests()) return null

    const iri = record?.['@id']
    const title = record?.title

    return (
        <ClientRequestsList
            client={{
                uuid,
                ...(typeof iri === 'string' && iri !== '' ? { '@id': iri } : {}),
                ...(typeof title === 'string' && title !== '' ? { title } : {}),
            }}
        />
    )
}
